import React from 'react'
import Link from 'gatsby-link'
import { colors } from '../styles/variables'

export default props => {
  const border = 2
  const height = 50
  const css = [
    {
      border: `${border}px solid ${colors.primary}`,
      borderRadius: height / 2,
      display: 'inline-block',
      fontFamily: 'Quicksand',
      fontWeight: 800,
      minHeight: height,
      lineHeight: '1.5em',
      padding: '0.8em 35px',
      textDecoration: 'none',
      transition:
        'color .2s cubic-bezier(0, 0, 0, 1), background .2s cubic-bezier(0, 0, 0, 1)',
    },
    props.type === 'ghost'
      ? {
          ':hover': {
            background: colors.primary,
            color: 'white',
          },
        }
      : {
          background: colors.primary,
          color: 'white',
          ':hover': {
            background: 'transparent',
            color: colors.primary,
          },
        },
    props.styles,
  ]

  if (props.to.indexOf('mailto:') === 0) {
    return (
      <a css={css} href={props.to}>
        {props.children}
      </a>
    )
  }

  return (
    <Link css={css} to={props.to}>
      {props.children}
    </Link>
  )
}
